import React from "react";
import { Form, Label, Col, Input, FormGroup, Button, Card, CardBody, Row } from "reactstrap";
// import Axios from "axios";
import ReactQuill from "react-quill";
import "quill/dist/quill.snow.css";
import Clock from "./Clock";
// import ButtonComponent from "../ButtonComponent";
import ImageWidget from "../ImageWidget";
import { toast } from 'react-toastify'

const MomDiaryForm = (props) => {
  
  const handleFileUpload = (event) => {
    let currentFiles = event.target.files;
    if(currentFiles.length > 4) {
      toast.error("Maximum of 4 files can be uploaded");
      return;
    }
    const types = ['image/png',  'image/jpeg', 'application/pdf']
    for(let file of currentFiles) {
      if(types.every(type => file.type !== type)) {
        toast.error(`${file.type} is not a supported format`);
        return;
      }
    }
    let files = [];
    for(let file of currentFiles) {
      files.push({filename: file.name, uploaded: false})
    }
    props.setFieldValue("documentFiles", [...props.status.uploadedFiles, ...files])
    props.setFieldValue("files", currentFiles);
  }

  return (
    <Form onSubmit={props.handleSubmit}>
      <Card>
        <CardBody>
          <Clock date={new Date()} />
          <FormGroup row>
            <Label
              className="col-lg-1"
              style={{ fontSize: "16px" }}
              for="Title"
              sm={1}
            >
              <b>Title:</b>
            </Label>
            <Col sm={8} className="col-lg-6">
              <Input
                required
                type="text"
                name="title"
                value={props.values.title}
                placeholder="Title"
                onChange={props.handleChange}
              />
            </Col>
          </FormGroup>
          <ReactQuill
            required
            theme="snow"
            className="quill"
            bounds={".app"}
            value={props.values.content}  
            // modules={this.modules}
            onChange={(content, delta, source, editor) => props.setFieldValue("content", editor.getHTML())}
          />
          <Row className="mt-2">
            <Col md="6">          
              <Label
                style={{ fontSize: "16px" }}
                for="Mood"
              >
                <b>Mood:</b>
              </Label>
              <Input
                required
                type="text"
                name="mood"
                value={props.values.mood}
                placeholder="Type your mood here"
                onChange={props.handleChange}
              />
            </Col>
            <Col md="3" className="ml-auto">            
              <Label
                // className="col-lg-1"
                style={{ fontSize: "16px" }}
                for="Files"
                className="mr-2"
              >
                <b>Upload Image:</b>
              </Label>
              <Button className="" onClick={() => this.fileInput.click()}>Upload</Button>                 
              <input className="d-none"
                type="file" 
                name="Files" 
                multiple
                ref={fileInput => this.fileInput = fileInput}
                onChange={handleFileUpload} 
                // onChange={(event) => {
                //   let files = [];
                //   for(let file of event.target.files) {
                //     files.push({filename: file.name, uploaded: false })
                //   }
                //   props.setFieldValue("documentFiles", [...props.status.uploadedFiles, ...files])
                //   props.setFieldValue("files", event.currentTarget.files)
                // }}
              />
              <p className="text-muted">*Formats JPEG, PNG, PDF only.<br />
                Maximum 4 files are allowed</p>
              <ImageWidget files={props.values.documentFiles} formType={props.formType} deleteImage={props.deleteImage}/>              
            </Col>
          </Row>
        </CardBody>
      </Card>
      <div className="text-center mt-4 pb-5">
        <Button type="submit" className="btn mr-2">Save</Button>
        <Button className="btn" onClick={props.goBack}>Go back</Button>
      </div>
    </Form>
  );
}

export default MomDiaryForm;



// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/MomDiary/MomDiaryForm.js